<template>
    <div>
        <!-- 定时购白名单批量导入抽屉（需求 7121828104，交互参考 import-whitelist.vue） -->
        <el-drawer
            title="定时购白名单导入"
            :visible.sync="drawerShow"
            :wrapperClosable="false"
            :destroy-on-close="true"
            size="auto"
            @close="close"
            append-to-body
        >
            <div class="drawer-content">
                <el-alert type="warning" :closable="false" class="MB10">
                    <div slot="title">导入为增量追加：文件内重复、或该票品下已存在的手机号自动跳过（不算错误）</div>
                </el-alert>
                <el-upload
                    drag
                    action
                    :http-request="uploadExcel"
                    :auto-upload="false"
                    ref="upload"
                    accept=".xls, .xlsx"
                    :show-file-list="true"
                    :before-upload="beforeUpload"
                    :file-list="fileList"
                    :on-change="onChange"
                    :on-remove="onRemove"
                    :disabled="uploadLoading">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
                    <div slot="tip" class="el-upload__tip color-danger">只能上传xls/xlsx文件，且最多不超过2W行<br>上传内容为用户手机号，系统识别文件第1列（第一行为表头「手机号」）</div>
                </el-upload>

                <div class="color-info">
                    导入文件示例如下:
                    <el-button
                        type="text"
                        icon="el-icon-download"
                        @click="download">
                        点击下载模板
                    </el-button>
                </div>

                <div class="temp-table">
                    <el-table
                        :data="tempModel"
                        style="width: 100%"
                        size="small"
                        border
                    >
                        <el-table-column prop="mobile" label="手机号"></el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="drawer-footer">
                <el-button v-if="!btnLoading" @click="close">取消</el-button>
                <el-button type="primary" @click="onSubmit" :loading="btnLoading" :disabled="canSubmit"
                    >提交</el-button>
            </div>

            <!-- 导入错误明细抽屉 -->
            <ErrorMsgDrawer ref="errorMsgDrawer" :maxlength="20000"></ErrorMsgDrawer>

        </el-drawer>
    </div>
</template>

<script>
// 定时购票品白名单批量导入（从 pre-buy-whitelist.vue 拆出）
import {downloadFileTmp,uploadFileTmp} from '@/assets/js/commonApi.js';
import ErrorMsgDrawer from '@/components/ErrorMsgDrawer';
export default {
    components:{ErrorMsgDrawer},
    data(){
        return{
            drawerShow:false,
            btnLoading:false,
            downLoading:false,
            uploadLoading:false,
            // 模板示例数据
            tempModel:[{
                mobile:'13800000000'
            },{
                mobile:'13900000000'
            }],
            canSubmit:true,
            fileList:[],
            skuId: '', // 票品ID
        }
    },
    methods:{
        // 打开抽屉（传入票品行数据）
        show(row) {
            this.skuId = row.id;
            this.drawerShow = true;
        },
        close(){
            this.fileList = [];
            this.$refs.upload.clearFiles();
            this.drawerShow = false;
        },
        //下载模板
        async download(){
            let filePath;
            this.downLoading = true;
            const res = await this.$request({
                url:'/preBuyWhitelist/downloadTemplate',
                method: 'post',
            })
                .catch(() => {
                    this.$message.error('请求错误');
                })
            if(!res) return;
            const{state,msg,result} = res.data;
            if(state == 1 && result && result.url){
                filePath = result.url;
            }else{
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }

            await downloadFileTmp(filePath, result.fileName || '定时购白名单导入模板.'+this.$utils.getFileType(filePath));
            this.downLoading = false;
        },
        //提交（触发上传）
        onSubmit(){
            this.$refs.upload.submit();
        },
        //上传并导入白名单
        async uploadExcel(req){
            this.btnLoading = true;
            this.uploadLoading = true;
            const formData = new FormData();
            formData.append('file', req.file);

            let filePath;
            const res = await uploadFileTmp(formData).catch(err => {
                this.$message({message: err.message, type: 'error'});
            }).finally(() => {
                this.uploadLoading = false;
            });
            const{state,msg,result} = res.data;
            if (state == 1 && result) {
                filePath = result.url;
            }else{
                this.btnLoading = false;
                return this.$message.error(msg || '上传失败');
            }

            // 调用白名单导入接口（skuId/filePath 走 query 传递）
            this.$request({
                url:'/preBuyWhitelist/importWhitelist',
                method: 'post',
                params:{
                    skuId: this.skuId,
                    filePath:filePath,
                }
            })
                .then(res => {
                    const{state,msg,result} = res.data;
                    if (state == 1) {
                        if(result && result.importErrorDetailVOList && result.importErrorDetailVOList.length > 0){
                            // 存在校验失败行：展示错误明细（正确行已增量导入）
                            this.$refs.errorMsgDrawer.show(result);
                            this.$emit('onUpdate');
                        }else{
                            this.onSuccess();
                        }

                    }else{
                        this.$message.error(msg || '上传失败');
                        this.canSubmit = false;
                    }
                })
                .catch(err => {
                    this.canSubmit = false;
                    this.$message({message: err.message, type: 'error'});
                })
                .finally(() => {
                    this.btnLoading = false;
                    this.canSubmit = true;
                });
        },
        //上传前校验文件格式
        beforeUpload(file){
            const type = this.$utils.getFileType(file.name)
            const isType = type === 'xls' || type === 'xlsx';
            if (!isType) {
                this.$message.error('仅支持xls、xlsx文件格式,请重新选择上传文件!');
            }
            return isType;
        },
        //导入成功
        onSuccess(){
            this.$message.success('导入成功');
            this.$emit('onUpdate');
            this.close();
        },
        //文件选择变化（回显文件名）
        onChange(file){
            if( file ){
                this.fileList = [{...file}]
                this.canSubmit = false;
            }else{
                this.canSubmit = true;
            }
        },
        //删除已选文件
        onRemove(){
            this.canSubmit = true;
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger,
::v-deep .el-upload{
    width: 100%;
}
::v-deep .el-upload__tip{
    color: #F56C6C;
}
.color-info{
    margin-top: 20px;
}
.el-table{
    margin-bottom: 10px;
}
</style>
